import React, { useState, useEffect } from 'react'
import { Github, Linkedin, Mail, Twitter } from 'lucide-react'

interface Profile {
  name: string
  email?: string
  social?: {
    github?: string
    linkedin?: string
    twitter?: string
    zhihu?: string
  }
}

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()
  const [profile, setProfile] = useState<Profile | null>(null)

  useEffect(() => {
    fetch('/api/blog-admin/profile')
      .then(res => res.json())
      .then(data => {
        if (data.success) setProfile(data.data)
      })
      .catch(console.error)
  }, [])

  const socialLinks = [
    {
      name: 'GitHub',
      icon: Github,
      url: profile?.social?.github || 'https://github.com/xxm-666',
      color: 'hover:text-gray-900 dark:hover:text-white',
    },
    {
      name: 'LinkedIn',
      icon: Linkedin,
      url: profile?.social?.linkedin || 'https://linkedin.com/in/lighting',
      color: 'hover:text-blue-600',
    },
    {
      name: 'Twitter',
      icon: Twitter,
      url: profile?.social?.twitter || 'https://twitter.com/lighting',
      color: 'hover:text-blue-400',
    },
    {
      name: 'Email',
      icon: Mail,
      url: profile?.email ? `mailto:${profile.email}` : 'mailto:living20250000@gmail.com',
      color: 'hover:text-red-500',
    },
  ]

  return (
    <footer className="mt-8 sm:mt-12 md:mt-16 border-t border-gray-200 dark:border-gray-800">
      <div className="w-full max-w-7xl mx-auto px-3 sm:px-4 py-6 sm:py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0">
          {/* Copyright */}
          <div className="mb-4 md:mb-0 text-center md:text-left">
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              © {currentYear} {profile?.name || 'LIGHTING'}. 保留所有权利.
            </p>
            <p className="text-gray-500 dark:text-gray-500 text-xs mt-1">
              原创内容，转载请注明出处
            </p>
            <p className="text-gray-500 dark:text-gray-500 text-xs">
              备案号: 皖ICP备2026004828号-1
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4 sm:gap-6">
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`text-gray-500 dark:text-gray-400 transition-colors ${link.color}`}
                aria-label={link.name}
              >
                <link.icon className="h-5 w-5" />
              </a>
            ))}
          </div>

          {/* Links */}
          <div className="mt-4 md:mt-0">
            <nav className="flex flex-wrap justify-center gap-4 text-sm">
              <a
                href="/privacy"
                className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
              >
                隐私政策
              </a>
              <a
                href="/terms"
                className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
              >
                使用条款
              </a>
              <a
                href="/sitemap"
                className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
              >
                网站地图
              </a>
            </nav>
          </div>
        </div>

        {/* Attribution */}
        <div className="mt-8 pt-8 border-t border-gray-200 dark:border-gray-800 text-center">
          <p className="text-gray-500 dark:text-gray-500 text-xs">
            由 React + TypeScript + Tailwind CSS 构建 • 部署于 Vercel
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer